<template>
    <div class="ck-item-box">
        <el-form :model="formData" :rules="rules" :inline="true" ref="form" size="mini" label-width="120px">
            <el-form-item label="Cookie名称" prop="ck_name">
                <el-input v-model="formData.ck_name" type="text"  placeholder="请输入Cookie名称" size="mini" class="ck-input-text"></el-input>
            </el-form-item>
            <el-form-item label="Cookie值" prop="ck_value">
                <el-input v-model="formData.ck_value" type="textarea" :rows="2" placeholder="请输入Cookie值" size="mini" class="ck-input"></el-input>
            </el-form-item> 
            <!-- 未定义变量 -->
            <el-form-item label="状态" prop="ck_status">
                <el-radio-group v-model="formData.ck_status">
                    <el-radio :label="1">启用</el-radio>
                    <el-radio :label="0">禁用</el-radio>
                </el-radio-group>
            </el-form-item>             
            <el-form-item label="CK状态">
                <el-tag class="mr20" size="small" :type="formData.ck_valid == 1 ? 'success' : 'danger'">{{formData.ck_valid==1?'生效': formData.ck_valid==0 ? '失效': formData.ck_valid==3 ?'未检测':''}}</el-tag>
            </el-form-item>     
             <el-form-item>
                <el-button type="primary" size="mini" @click="CKValidCheck" :disabled="ckData.loading || !formData.ck_value">检查CK状态</el-button>
                <el-button class="dialog-btn" type="primary" size="mini" @click="sure" :disabled="loading || !formData.ck_value">保 存</el-button>
                <el-button class="dialog-btn" type="danger" size="mini"  @click="deleteItem">删 除</el-button>
            </el-form-item>   
             <!-- <el-form-item>
            </el-form-item>            -->
        </el-form>      
       
    </div>
</template>
<script>
 export default {
    name: 'CKItem',
    props:{
        loading:{
            type: Boolean,
            default: false,
        },
        form:{
            type: Object,            
            required:true,
            default:{},            
        },
        index:{
            type: Number,
            default: 0,

        }

    },
       data(){        
           
        return {
            rules:{
                ck_name:[ { required: true, message: '请输入Cookie名称', trigger: 'blur' },],
                ck_value:[
                        { required: true, message: '请输入Cookie值', trigger: 'blur' },
                        //至少3个字符   
                        { min: 3, message: '长度至少3个字符', trigger: 'blur' },
                     ],
                    ck_status:[
                        { required: true, message: '请选择状态', trigger: 'blur' },
                    ],
            },
            formData:{
                ck_value:'',
                ck_status:1,
                ck_name:'',
                ck_valid:3,
              
            },
            ckData:{
                loading:false,
                // ck_valid_data:{
                //     ck_valid:3,
                //     ck_valid_text:'未检测',
                // },
            }
        }
    },
    mounted() { 
        for (const key in this.form) {
            if(key !== 'loading'){
                this.$set(this.formData, key, this.form[key]);
            }
            
        }
    },

    methods: {     
        sure(){
            console.log(this.formData,'formData')
            this.$refs['form'].validate((valid) => {
                    if (valid) {          
                          let param = {
                            ...this.formData
                          }
                        this.$emit("sureItem",param)
                       
                    } else {
                        return false;
                    }
                });    
        },
        //验证ck是否生效
        CKValidCheck(){
            this.ckData.loading = true
            this.$api.checkCkValid({
                ck_id:this.formData.id,
                ck_value:this.formData.ck_value
            }).then(res=>{
                this.ckData.loading = false
                this.formData.ck_valid = res.data.ck_valid
            }).catch(e=>{
                this.ckData.loading = false
            })
        },
        deleteItem(){   
            this.$emit("deleteItem",this.formData,this.index)
        }
    },
    // 监听 当form 更新时，同步更新this.FormData
    watch:{
        form:{
            handler(newVal){
                for (const key in newVal) {
                   
                    this.$set(this.formData, key, newVal[key]);
                }
            },
            deep:true
        },
        
    }
}

</script>
<style lang="scss" scoped>
.ck-item-box{
    // display: flex;
    // align-items: center;
    .ck-input-text{
        width:150px;
    }
    .ck-input{
        width: 400px
    }
}
</style>